module.exports = __webpack_public_path__ + "img/student_title_bankground.a8e2e357.png";